<template>
  <div class="border-dark-purple">
    <div class="row card-body-noBorder">
      <div class="col-lg-12 col-xs-12">
        <div class="card-body-noBorder" style="background-color: #eaeaea">
          <div v-show="!is_candidate" class="col-lg-12">
            <CurriculumUpload :id="id" />
          </div>
          <div class="col-lg-12 col-xs-12">
            <!-- <h3 class="color-dark-purple">CURRÍCULO DO CANDIDATO</h3> -->
            <BtnDonwloadCV :id="uid" :account_uid="account_uid" class="mr-5" />
          </div>
          <pre class="resume_pre">{{ resume || resume_preview }}</pre>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BtnDonwloadCV from "components/ButtonDonwloadCV.vue";
import CurriculumUpload from "components/CurriculumUpload.vue";

export default {
  props: ["resume", "id", "uid", "account_uid", "is_candidate"],
  components: { BtnDonwloadCV, CurriculumUpload },

  data() {
    return {
      resume_preview: "",
    };
  },

  mounted() {
    if (this.is_candidate == true) {
      this.resume_preview = this.resume;
    } else {
      this.getCurriculum();
      eventBus.$on("validate_curriculum", (response) => {
        if (response.status == true) {
          this.getCurriculum();
          this.$toast.success("Currículo anexado com sucesso");
        }
      });
    }
  },

  methods: {
    async getCurriculum() {
      await axios
        .get("/recruiters/curriculum", {
          params: {
            candidate_id: this.id,
          },
        })
        .then((response) => {
          this.resume_preview = response.data.candidate.curriculum_text;
        });
    },
  },
};
</script>
